import React from 'react';

const SvgThreeDot = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 13 3" {...props}>
    <g fill="currentColor">
      <circle cx={1.7} cy={1.5} r={1.5} />
      <circle cx={6.5} cy={1.5} r={1.5} />
      <circle cx={11.3} cy={1.5} r={1.5} />
    </g>
  </svg>
);

export default SvgThreeDot;
